export class Discriminators {
  public static readonly ResponsivePaymentDetails = 'ResponsivePaymentDetails';
  public static readonly NonResponsivePaymentDetails = 'NonResponsivePaymentDetails';
  public static readonly ResidentialCoverage = 'ResidentialCoverage';
}
